const fullFromLanguage = {
    "en": "English",
    "ar": "Arabic",
    "de": "German",
    "es": "Spanish",
    "fr": "French",
    "hi": "Hindi",
    "id": "Indonesian",
    "it": "Italian",
    "ja": "Japanese",
    "ko": "Korean",
    "pt": "Portuguese",
    "ru": "Russian",
    "tr": "Turkish",
    "zh": "Chinese",
    "mr": "Marathi",
    "gu": "Gujarati"
  }
export default function formatLanguage(lang) {
    return fullFromLanguage[lang] || lang
}
